import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import UsersData from './UsersData';
import OdoUsers from './OdoUsers';
import './user.css'
const User = () => {
  return (
    <div className="p-3">
      <div className='d-flex gap-3 justify-content-between mb-3'>
        <h1 className='cmn_heading'>App Users</h1>
      </div>
      <Tabs defaultActiveKey="users" id="user-tabs" className="mb-3">
        <Tab eventKey="users" title="App Users">
          <UsersData />
        </Tab>
        <Tab eventKey="odoUsers" title="Odoo Leads">
          <OdoUsers />
        </Tab>
      </Tabs>
    </div>
  );
};

export default User;
